export default "__VITE_ASSET__BBxMJztF__"